module.exports = __webpack_public_path__ + "static/success1-fb92823ebbce2b91d88bb767cb0c35ee.png";